export class Reducer {
	constructor(key, path, actionHandlers) {
		this.key = key;
		this.path = path;
		this.actionHandlers = actionHandlers;
	}

	get fullPath() {
		return this.path ? this.path + '.' + this.key : this.key;
	}
}
